import React, { useEffect, useMemo, useState } from "react";
import { object } from "prop-types";

import { Col, Row } from "reactstrap";
import "./buttonSelectSingleClient.css";
import { LegalEntityIcon, NaturalPersonIcon } from "../../../assets";
import { optionsType } from "../../../prop-types";

export const CLIENT_TYPE_VALUES = {
  PERSON: "Person",
  COMPANY: "Company",
};

export const CLIENT_TYPE_LABELS = {
  Person: "Natural Person",
  Company: "Legal Entity",
};

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
};

const ButtonSelectSingleClient = ({
  options,
  field,
  form: { setFieldValue },
}) => {
  const [groupedOptions, setGroupedOptions] = useState({
    [CLIENT_TYPE_VALUES.COMPANY]: [],
    [CLIENT_TYPE_VALUES.PERSON]: [],
  });

  const value = getValue(options, field);

  useEffect(() => {
    if (options) {
      const tempGroup = {
        [CLIENT_TYPE_VALUES.COMPANY]: [],
        [CLIENT_TYPE_VALUES.PERSON]: [],
      };

      options.map((option) => {
        if (tempGroup[option.targetTypeCategory]) {
          tempGroup[option.targetTypeCategory].push(option);
        }

        return null;
      });

      setGroupedOptions(tempGroup);
    }
  }, [options]);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.category)
      ? option.map((item) => item.category)
      : option.category;

    return setFieldValue(field.name, newValue);
  };

  const getClassName = (option) => {
    const base =
      "d-flex justify-content-between selectable-button align-items-center ";
    if (!value.length) {
      return base;
    }

    if (option.category === value[0].value) {
      return base + "active-selectable-button";
    }
    return base;
  };

  function RenderIcon({ optionValue = "" }) {
    if (optionValue === CLIENT_TYPE_VALUES.PERSON) {
      return <NaturalPersonIcon width={16} height={16} />;
    }

    if (optionValue === CLIENT_TYPE_VALUES.COMPANY) {
      return <LegalEntityIcon width={16} height={16} />;
    }

    return null;
  }

  const RenderOption = ({ option, type }) => {
    const render = useMemo(() => {
      const opt = option[0];
      if (option.length) {
        return (
          <div
            className={getClassName(opt)}
            color="primary"
            outline
            onClick={() => handleChange(opt)}
          >
            <RenderIcon optionValue={opt.targetTypeCategory} />
            <span>{CLIENT_TYPE_LABELS[opt.targetTypeCategory]}</span>
            <div />
          </div>
        );
      } else {
        return (
          <div
            className="d-flex justify-content-between align-items-center no-option"
            color="primary"
            outline
            onClick={() => {}}
          >
            <RenderIcon optionValue={type} />
            <span>{type}</span>
            <div />
          </div>
        );
      }
    }, [option]);
    return render;
  };

  return (
    <Row>
      <Col lg={6} className="pr-2">
        <RenderOption
          option={groupedOptions[CLIENT_TYPE_VALUES.PERSON]}
          type={CLIENT_TYPE_VALUES.PERSON}
        />
      </Col>
      <Col lg={6} className="pl-2">
        <RenderOption
          option={groupedOptions[CLIENT_TYPE_VALUES.COMPANY]}
          type={CLIENT_TYPE_VALUES.COMPANY}
        />
      </Col>
    </Row>
  );
};

ButtonSelectSingleClient.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default ButtonSelectSingleClient;



// WEBPACK FOOTER //
// ./src/components/formik/client-profile-button-select/ButtonSelectSingleClient.jsx